import React from 'react';
import { colors, borderRadius, typography } from '../../styles/theme';

/**
 * Badge Component - Status/label indicator
 * @param {Object} props
 * @param {React.ReactNode} props.children - Badge content
 * @param {string} props.variant - 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info'
 * @param {string} props.size - 'sm' | 'md'
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Additional inline styles
 */
function Badge({
  children,
  variant = 'default',
  size = 'md',
  className = '',
  style = {},
}) {
  const sizeMap = {
    sm: {
      padding: '2px 8px',
      fontSize: typography.fontSize.xs,
    },
    md: {
      padding: '4px 12px',
      fontSize: typography.fontSize.sm,
    },
  };

  const variantStyles = {
    default: {
      backgroundColor: colors.surfaceHover,
      color: colors.textSecondary,
    },
    primary: {
      backgroundColor: colors.accentLight,
      color: colors.accent,
    },
    success: {
      backgroundColor: colors.successLight,
      color: colors.success,
    },
    warning: {
      backgroundColor: colors.warningLight,
      color: '#856404',
    },
    danger: {
      backgroundColor: colors.dangerLight,
      color: colors.danger,
    },
    info: {
      backgroundColor: colors.infoLight,
      color: '#055160',
    },
  };

  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: borderRadius.full,
    fontWeight: typography.fontWeight.semibold,
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
    whiteSpace: 'nowrap',
    ...sizeMap[size],
    ...variantStyles[variant],
    ...style,
  };

  return (
    <span className={`badge badge-${variant} ${className}`} style={baseStyles}>
      {children}
    </span>
  );
}

export default Badge;
